import { computed } from "vue";
import { createQuery } from "@/queries";
import { getCategoryTree } from "@/features/search/api/categories";
import type { MenuRoot } from "@/types/menuItemTypes";

export const useCategoryTreeQuery = () => {
  return createQuery<MenuRoot>({
    key: computed(() => ["categories", "tree"]),
    fetcher: () => getCategoryTree(),
    // The tree changes on catalogue ingest, not per navigation.
    staleTime: 30 * 60 * 1000,
    enabled: computed(() => true),
  });
};
